export default __webpack_public_path__ + "static/aftia-3c95c44aac7a5f61b2d4d47ff2ac4a6b.png";